import { useCallback } from 'react';

export interface ToastOptions {
  title: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

/**
 * Simple toast notification hook
 * TODO: Replace with a real toast library (e.g., react-hot-toast, sonner).
 * Currently logs to console so all toast types produce visible dev feedback
 * without blocking the main thread via alert().
 */
export const useToast = () => {
  const showToast = useCallback((options: ToastOptions) => {
    const { title, message, type } = options;
    const fullMessage = `[${type.toUpperCase()}] ${title}: ${message}`;

    if (type === 'error') {
      console.error(fullMessage);
    } else {
      // eslint-disable-next-line no-console
      console.log(fullMessage);
    }
  }, []);

  return { showToast };
};
